"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_IMAGE_WIDTH = exports.AVAILABLE_IMAGE_WIDTH = void 0;
var lodash_1 = require("lodash");
// NOTE: 120, 240 and 480 widths are predefined youtube thumbnails sizes
exports.AVAILABLE_IMAGE_WIDTH = [
    90, 120, 180, 320, 360, 480, 540, 768, 1024, 1280, 1366, 1440, 1600, 1680,
    1920, 2560,
];
exports.MAX_IMAGE_WIDTH = (0, lodash_1.last)(exports.AVAILABLE_IMAGE_WIDTH);
//# sourceMappingURL=image-sizes.js.map